import { render, staticRenderFns } from "./jinrihuangzhe.vue?vue&type=template&id=2ab6151c&scoped=true"
import script from "./jinrihuangzhe.vue?vue&type=script&lang=js"
export * from "./jinrihuangzhe.vue?vue&type=script&lang=js"
import style0 from "./jinrihuangzhe.vue?vue&type=style&index=0&id=2ab6151c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab6151c",
  null
  
)

export default component.exports